// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"30a1a697","787":"224c719d"}[chunkId] + ".chunk.js";
};